import { IClientProductGateway, MapProductInput, PresenterFunc } from '@/core/interface';
import { MapClientProduct } from '@/core/usecase/client/map-client-product';
import { ClientProduct } from '@/core/entity';
import { Fragment, UpdaterFunc } from '@/core/interface/common';

export class ClientProductController {
  constructor(
    private readonly clientProductGw: IClientProductGateway,
  ) { }

  public mapClientProduct(
    input: MapProductInput,
    presenter: PresenterFunc<ClientProduct | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    const useCase = new MapClientProduct(this.clientProductGw);

    useCase.execute(input, presenter, fragment, updater);
  }
}
